import { InformationCircleIcon } from '@heroicons/react/24/outline';
import './EncryptedContent.styles.scss';
import { Tooltip } from 'react-daisyui';
import { useTranslation } from 'react-i18next';

export default function EncryptedContent() {
  const { t } = useTranslation('chat/chat');

  return (
    <div className="EncryptedContent">
      <div className="EncryptedContent__Text">
        <p className="flex items-center">
          {t('messageNotDelivered.title')}
          <Tooltip
            className="ml-1 z-50"
            message={t('messageNotDelivered.tooltip')}
          >
            <InformationCircleIcon className="w-5 h-5 d-flex items-center justify-center text-primary" />
          </Tooltip>
        </p>
        <a
          href="https://faq.whatsapp.com/3398056720476987"
          target="_blank"
          className="EncryptedContent__Text__Link"
        >
          {t('messageNotDelivered.link')}
        </a>
      </div>
    </div>
  );
}
